/**
 * Warstwa API: kategorie główne zgłoszeń i AUTOMAPOWANIE (polecenie właściciela 2026-09-30, obszar F / E1).
 *
 * Cytat: „w szczegółach zgłoszenia, w filtrach zaawansowanych trzeba dodać przycisk «automapowanie», który
 * prześledzi aktualne dodane reguły i słowniki i zrobi automapowanie zgłoszeń, nawet tych zdefiniowanych, dla porządku”.
 *
 * Trasy backendu (`TicketsController`, bramka `CategoryManage` + zakres kolejki wołającego):
 *  • `POST tickets/automapowanie/podglad`  — przeliczenie BEZ zapisu: lista zmian (zgłoszenie, stara → nowa kategoria,
 *                                            źródło: reguła + fraza albo kategoria główna + słowa) i SKRÓT podglądu,
 *  • `POST tickets/automapowanie/zastosuj` — zapis zatwierdzonego podglądu: `{ parametry, skrot, odznaczone }`;
 *                                            serwer przelicza jeszcze raz i odmawia 409 (`automapowanie_rozjazd`),
 *                                            gdy wynik różni się od podglądu; 503 = funkcja jeszcze niedostępna.
 *
 * Oba wywołania to POST z ciałem — treść parametrów nie idzie w adresie (dziennik serwera, historia przeglądarki).
 */
export function attach(api) {
    return {
        /** @param {{ moduleCode: string, handlingDepartmentId?: string|null, takzeSkategoryzowane?: boolean, limit?: number }} parametry */
        automapowaniePodglad: (parametry) => api.post("/tickets/automapowanie/podglad", parametry),
        /** @param {{ parametry: object, skrot: string, odznaczone: string[] }} dane */
        automapowanieZastosuj: (dane) => api.post("/tickets/automapowanie/zastosuj", dane),
    };
}
